export enum ObjectType {
  CondominiumUnit = 'condominiumUnit',
  Residence = 'residence',
  Others = 'others'
}

export type ClaimItem = {
  claimID: string
  insuranceClaimReference: string
  lossAdjusterClaimReference: string
  condominiumName: string
  address: string
  unitOwnerName: string
  unitNumber: string
  adjusterUserID: string
  adjusterUserEmail: string
  adjusterUserFullName: string
  adjusterCompanyID: string
  insuranceCompanyID: string
  adjustmentMethod: string
  createdAt: string
  modifiedAt: string
  status: string
  attachmentFilesCount: number
  noChanges: boolean | undefined
  deed: boolean | undefined
  savingAmount: string | number | undefined

  // New fields - always present in backend response
  objectType: string
  claimType: string           // Default: "earthquake"
  policyLimit: number         // Default: 0
  policyNumber: string        // Default: ""
}
